export default __webpack_public_path__ + "static/media/poster-crazy6.7b03bc26.png";